import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ActivityService } from './api/activity.service';
import { AdminCompetitionService } from './api/adminCompetition.service';
import { AdminContactService } from './api/adminContact.service';
import { AdminDeviceService } from './api/adminDevice.service';
import { AdminProjectService } from './api/adminProject.service';
import { AdminSchoolService } from './api/adminSchool.service';
import { AdminSurveyService } from './api/adminSurvey.service';
import { AnalyticsService } from './api/analytics.service';
import { AssertionService } from './api/assertion.service';
import { BadgeService } from './api/badge.service';
import { BakedBadgeService } from './api/bakedBadge.service';
import { ContactMethodsService } from './api/contactMethods.service';
import { DECService } from './api/dEC.service';
import { DeviceService } from './api/device.service';
import { ImageService } from './api/image.service';
import { IssuerService } from './api/issuer.service';
import { JudgeService } from './api/judge.service';
import { OnlineEssayService } from './api/onlineEssay.service';
import { ParticipantService } from './api/participant.service';
import { ProgramService } from './api/program.service';
import { ProjectService } from './api/project.service';
import { ProjectDocumentsService } from './api/projectDocuments.service';
import { PublicBookshopService } from './api/publicBookshop.service';
import { PublicDeviceService } from './api/publicDevice.service';
import { PublicSurveyService } from './api/publicSurvey.service';
import { SchoolService } from './api/school.service';
import { SignUpService } from './api/signUp.service';
import { TeacherSubjectService } from './api/teacherSubject.service';
import { UserDashboardService } from './api/userDashboard.service';
import { UserManagerService } from './api/userManager.service';
import { UserParticipantsService } from './api/userParticipants.service';
import { VerbXApiService } from './api/verbXApi.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
